export function accordion() {
    let $accordionItem = $(".accordion-item h4 > a");
    $accordionItem.on("click", function (e) {
        e.preventDefault();
        let $this = $(this);
        if (!$this.hasClass("active")) {
            $accordionItem.removeClass("active").parent().next().slideUp(400);
            $this.addClass("active").parent().next().slideDown(400);
        }
    });
    $(".accordion").each(function () {
        if (!$('.accordion-item:first-child h4 > a').hasClass('active')) {
            $(this).find(".accordion-item:first-child h4 > a").trigger('click');
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js